import { Box } from "@mui/material";
import { isEmpty, isNil } from "lodash";
import { useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import PrimaryContentCard from "../../../../../_src_shared/components/layout/PrimaryContentCard";
import { loanDrilldownSidebarTypes } from "../../../../../constants/enums/loanDrilldownScreenSidebarOptions";
import {
  sidebarSetParamsValue,
  sidebarSetStateValue,
  sidebarTypeSet,
} from "../../../../../redux/actions/sidebarActions";
import LoanDrilldownButtonSidebarAdd from "../../../buttons/LoanDrilldownButtonSidebarAdd";
import OriginatorFeesTable from "../tables/OriginatorFeesTable";
import InsetCard from "../../../../../components/ui/InsetCard";

const ITEM_NAME = "Third Party Fee";
const SIDEBAR_TYPE = loanDrilldownSidebarTypes.ADD_EDIT_THIRD_PARTY_FEES;
const LoanFeesSubTabThirdPartyFees = () => {
  const loanTerms = useSelector((state) => state?.loanFetchedData?.loanTerms);
  const dispatch = useDispatch();

  const rowData = useMemo(
    () => loanTerms?.thirdPartyFees || [],
    [loanTerms?.thirdPartyFees]
  );
  const headerSubtitle = useMemo(() => {
    if (isEmpty(rowData)) {
      return `Add and manage ${ITEM_NAME.toLowerCase()}s associated with this loan.`;
    }
    return `Click any of the following rows to edit a ${ITEM_NAME.toLowerCase()}`;
  }, [rowData]);

  const onRowClicked = useCallback((d) => {
    dispatch(sidebarTypeSet(SIDEBAR_TYPE));
    dispatch(sidebarSetParamsValue(null));
    dispatch(sidebarSetStateValue(d));
  }, []);

  return (
    <PrimaryContentCard
      maxWidth="lg"
      title={ITEM_NAME + "s"}
      subTitle={headerSubtitle}
      endContent={
        <LoanDrilldownButtonSidebarAdd type={SIDEBAR_TYPE}>
          Add {ITEM_NAME}
        </LoanDrilldownButtonSidebarAdd>
      }
      loading={isNil(loanTerms)}
      // cardSx={{ pb: 0 }}
    >
      <InsetCard sx={{ p: 0, overflow: "hidden" }}>
        <OriginatorFeesTable onRowClicked={onRowClicked} rowData={rowData} />
      </InsetCard>
    </PrimaryContentCard>
  );
};

export default LoanFeesSubTabThirdPartyFees;
